import axios from "axios";
import { config } from './config.js';
import {SecureStoragePlugin} from "capacitor-secure-storage-plugin";
import { v4 as uuidv4 } from 'uuid';
import {computed, ref} from "vue";
import {alertController} from "@ionic/vue";
import i18n from "@/i18n";

export default new function () {
    const self = this;
    self.devices = {};
    self.user = {};
    self.email = null;
    self.isShowAlert  = ref(false)

    self.getOrCreateDeviceId = async () => {
        try {
            const result = await SecureStoragePlugin.get({ key: 'device_id' });
            return result.value;
        } catch {
            const newId = uuidv4();
            await SecureStoragePlugin.set({ key: 'device_id', value: newId });
            return newId;
        }
    }

    self.handleApiError = async (error) => {
        console.log('[dh.matrix][ApiError] Undexcepted error', error);
        let alert = await alertController.create({
            header: i18n.global.t('error'),
            message: i18n.global.t('errorInRequestPleaseTryAgainLater'),
            buttons: ['OK'],
        });

        await alert.present();
    }

    self.check = async (loginResponse) => {
        self.user = loginResponse.user;
        self.email = loginResponse.selectedIdentity.email;

        if (self.user.origUserId !== undefined) {
            self.user.userId = self.user.origUserId;
        }

        const postData = {
            userId: self.user.userId,
            deviceId: await self.getOrCreateDeviceId()
        }
        self.devices = await axios.post(`${config.api.baseURL}type/getUserDevice`, postData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
            .then((resp) => resp.data)
            .catch(self.handleApiError)

        const isPrimary = self.devices.matchedDevice && !!Number.parseInt(self.devices.matchedDevice.primaryDevice);
        window.localStorage.setItem('isPrimary', isPrimary ? 1 : 0);
    };


    self.getEmailIsApprovedForSetPrimaryDevice = async (hash) => {
        const postData = {
            hashForApp: hash,
        }

        return await axios.post(`${config.api.baseURL}type/checkUserDeviceAsPrimaryProcess`, postData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }).then(resp => resp.data.signed)
    }

    self.sendApproveEmailForSetPrimaryDevice = async () => {
        const postData = {
            userId: self.user.userId,
            deviceId: await self.getOrCreateDeviceId(),
            primaryDevice: 1
        }
        return await axios.post(`${config.api.baseURL}type/saveUserDevice`, postData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }).then(resp => resp.data)
    }

    self.saveAsSecondaryDevice = async () => {
        const postData = {
            userId: self.user.userId,
            deviceId: await self.getOrCreateDeviceId(),
            primaryDevice: 0
        }
        return await axios.post(`${config.api.baseURL}type/saveUserDevice`, postData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }).then(resp => resp.data)
    }

    self.send2FaApproveRequestToPrimaryDevice = async () => {
        const postData = {
            userId: self.user.userId
        }
        return await axios.post(`${config.api.baseURL}type/createMobileAppTwoFactorToken`, postData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }).then(resp => resp.data)
    }

    self.getIs2FaApproveRequestDone = async (token) => {
        const postData = {
            userId: self.user.userId,
            token
        }
        return await axios.post(`${config.api.baseURL}type/checkMobileAppTwoFactorToken`, postData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }).then(resp => resp.data.complete)
    }

    self.isFirstDevice = computed( () => {
        return !self.devices.allDevices || self.devices.allDevices.length === 0;
    });

    self.isPrimary = () => {
        return Number.parseInt(window.localStorage.getItem('isPrimary') ?? "1")
    };

}